import React, { Component } from "react";
import defaultBg from "../images/room-4.jpeg";
// import Hero from "../components/Hero";
import Banner from "../components/Banner";
import { Link } from "react-router-dom";
import { RoomContext } from "../context";
import StyledHero from "../components/StyledHero";
import styled from "styled-components";

const SingleRoomSection = styled.section`
  padding: 5rem 0 0 0;
`;
const SingleRoomImages = styled.div`
  width: 80vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 50px;
  img {
    width: 100%;
    display: block;
  }
  @media screen and (min-width: 992px) {
    width: 95vw;
    max-width: 1170px;
  }
`;
const SingleRoomInfo = styled.div`
  width: 80vw;
  display: grid;
  grid-template-columns: 1fr;
  margin: 2rem auto;
  @media screen and (min-width: 992px) {
    width: 95vw;
    max-width: 1170px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
  }
`;
const Desc = styled.article`
  margin: 1rem auto;
  h3 {
    text-transform: capitalize;
    letter-spacing: 3px;
  }
  p {
    line-height: 1.5;
  }
`;
const Info = styled.article`
  margin: 1rem auto;
  h3 {
    text-transform: capitalize;
    letter-spacing: 3px;
  }
  h6 {
    text-transform: capitalize;
    letter-spacing: 3px;
    font-weight: 300;
  }
  @media screen and (min-width: 992px) {
    padding-left: 3rem;
  }
`;
const RoomExtras = styled.section`
  width: 80vw;
  margin: 0 auto 3rem auto;
  h6 {
    text-transform: capitalize;
    letter-spacing: 3px;
  }
  @media screen and (min-width: 992px) {
    width: 95vw;
    max-width: 1170px;
  }
`;
const Extras = styled.ul`
  list-style-type: none;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
  grid-column-gap: 2rem;
  grid-row-gap: 1rem;
`;
export default class SingleRoom extends Component {
  constructor(props) {
    super(props);
    //console.log(this.props);
    this.state = {
      slug: this.props.match.params.slug,
      defaultBg: defaultBg,
    };
  }
  static contextType = RoomContext;
  componentDidMount() {}
  render() {
    const { getRoom } = this.context;
    const room = getRoom(this.state.slug);
    //console.log(room);
    if (!room) {
      return (
        <div className="error">
          <h3>No Such Room Is Found...</h3>
          <Link to="/rooms" className="btn-primary">
            Back to Rooms
          </Link>
        </div>
      );
    }
    const {
      name,
      description,
      capacity,
      size,
      price,
      extras,
      breakfast,
      pets,
      images,
    } = room;
    const [mainImg, ...defaultImg] = images;
    return (
      <>
        <StyledHero img={mainImg || this.state.defaultBg}>
          <Banner title={`${name} room`}>
            <Link to="/rooms" className="btn-primary">
              Back to Rooms
            </Link>
          </Banner>
        </StyledHero>
        <SingleRoomSection>
          <SingleRoomImages>
            {defaultImg.map((item, index) => {
              return <img key={index} src={item} alt={name} />;
            })}
          </SingleRoomImages>
          <SingleRoomInfo>
            <Desc>
              <h3>Details</h3>
              <p>{description}</p>
            </Desc>
            <Info>
              <h3>Info</h3>
              <h6>Price: ${price}</h6>
              <h6>Size: ${size} SQFT</h6>
              <h6>
                Max Capacity:{" "}
                {capacity > 1 ? `${capacity} people` : `${capacity} person`}
              </h6>
              <h6>{pets ? "pets allowed" : "no pets allowed"}</h6>
              <h6>{breakfast && "free breakfast included"}</h6>
            </Info>
          </SingleRoomInfo>
        </SingleRoomSection>
        <RoomExtras>
          <h6>Extras</h6>
          <Extras>
            {extras.map((item, index) => {
              return <li key={index}>- {item}</li>;
            })}
          </Extras>
        </RoomExtras>
      </>
    );
  }
}
